<template>
  <span class="sorter" @click="$emit('sort', field)">
    <slot />
    <Icon name="asc" width="16" height="16" v-if="$parent.form.field === field && $parent.form.direction === 'asc'" />
    <Icon name="desc" width="16" height="16" v-if="$parent.form.field === field && $parent.form.direction === 'desc'" />
  </span>
</template>

<script>
import Icon from '@/Shared/Icon'
export default {
  components: {
    Icon
  },
  props: {
    field: String,
  },
  emits: ['update:modelValue', 'sort'],
}
</script>

<style lang="scss" scoped>
.sorter {
  cursor: pointer;
}
</style>
